import * as TYPES from '../../store/types'

const state = {
  filter: {},
}

/* eslint-disable no-param-reassign */
const mutations = {
  [TYPES.ORDERCONTROL_SET_FILTER](st, obj) {
    if (obj.filter) {
      st.filter = obj.filter
    }
  },
}

const actions = {
  ordercontrolSetFilter({ commit }, obj) {
    commit(TYPES.ORDERCONTROL_SET_FILTER, obj)
  },
}

const module = {
  state,
  mutations,
  actions,
}

export default { module }
